/**
 * Application-wide constants — GenesisBox
 */

export const APP_NAME = 'GenesisBox';

/** localStorage key prefix */
export const STORAGE_PREFIX = 'genesisbox';

/** Local saved-connection keys */
export const CONNECTION_KEYS = {
  savedConnections: 'savedConnections',
  activeConnectionId: 'activeConnectionId',
} as const;

/** Request headers */
export const REQUEST_HEADERS = {
  activeConnection: 'x-genesisbox-connection',
  activeConnectionId: 'x-genesisbox-connection-id',
  activeOrgId: 'x-genesisbox-org-id',
} as const;

/** Upload limits */
export const UPLOAD_MAX_SIZE = 100 * 1024 * 1024; // 100 MB

/** API paths */
export const API_PATHS = {
  health: '/health',
  files: '/api/files',
  download: '/api/files/download',
  url: '/api/files/url',
  uploadUrl: '/api/files/upload-url',
  upload: '/api/files/upload',
  folder: '/api/files/folder',
  move: '/api/files/move',
} as const;
